import React from 'react';
import { cn } from '../../lib/cn';
import { METRIC_ACCENTS } from '../../utils/commandCenterHelpers';

// Gradient metric tile: icon + big number + label.
export default function MetricTile({ icon: Icon, label, value, accent = 'brand', hint }) {
  return (
    <div
      className={cn(
        'relative overflow-hidden rounded-2xl bg-gradient-to-br text-white p-4 sm:p-5 shadow-lift',
        METRIC_ACCENTS[accent] || METRIC_ACCENTS.brand
      )}
    >
      <div className="pointer-events-none absolute -right-6 -top-6 h-24 w-24 rounded-full bg-white/10 blur-xl" />
      <div className="relative flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-[11.5px] font-medium uppercase tracking-wider text-white/70">{label}</p>
          <p className="mt-1.5 text-[30px] font-semibold leading-none tabular-nums">{value}</p>
          {hint ? <p className="mt-1.5 text-[11.5px] text-white/70">{hint}</p> : null}
        </div>
        {Icon ? (
          <span className="h-9 w-9 rounded-xl bg-white/15 inline-flex items-center justify-center shrink-0">
            <Icon className="h-4.5 w-4.5" />
          </span>
        ) : null}
      </div>
    </div>
  );
}
